<template>
  <el-dialog
    class="mazhenguo"
    title="文件预览"
    :close-on-click-modal="false"
    :visible.sync="dlgState"
    append-to-body
    width="60%"
    top="30px"
  >
    <div v-if="dlgState" >
    <!-- dlgData.id=={{dlgData.id}} -->
      <!-- dlgData.fileType=={{dlgData.fileType}}<br/>
      dlgData.viewUrl== {{dlgData.viewUrl}}<br/>
      dlgData.fileUrl== {{dlgData.fileUrl}}<br/> -->

      <div v-if="dlgData.fileType === '33'">
        <video-player v-model="dlgData.fileUrl" :ref-id="dlgData.id" />
      </div>
      <pdf-reader v-if="dlgData.fileType === '11'" :src="dlgData.viewUrl" />
      <pdf-reader v-if="dlgData.fileType === '22'" :src="dlgData.fileUrl" />

      <img  v-if="dlgData.fileType === '44'" width="100%" :src="dlgData.viewUrl" alt="" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDlg" icon="el-icon-back">返回</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  props: {
    dlgState0: {
      type: Boolean,
      default: false
    },
    dlgData0: {}
  },
  watch: {
    dlgState0(val) {
      this.dlgState = val;
    },
    dlgState(val) {
      if (val) {
        setTimeout(() => {
          this.dlgData = this.dlgData0;
        }, 50);
      } else {
        this.$emit("closeDlg");
      }
    }
  },
  data() {
    return {
      // 弹窗
      dlgState: false,

      dlgLoading: false,
      dlgData: {}
    };
  },
  created() {},
  methods: {
    closeDlg() {
      this.dlgState = false;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped></style>
